import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CalendarCheck, CalendarX, Download, Loader2 } from "lucide-react";
import { LegalShell } from "./Legal";
import { http, API, errorText } from "@/lib/api";

export default function ManageBooking() {
  const [sp] = useSearchParams();
  const id = sp.get("id") || "", token = sp.get("token") || "";
  const [b, setB] = useState(null);
  const [err, setErr] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    document.title = "Ihr Termin – Webhaus";
    http.get(`/bookings/${encodeURIComponent(id)}`, { params: { token } }).then(({ data }) => setB(data)).catch((e) => setErr(errorText(e, "Termin nicht gefunden.")));
  }, [id, token]);

  const cancel = async () => {
    setBusy(true);
    try { const { data } = await http.post(`/bookings/${encodeURIComponent(id)}/cancel`, { token }); setB(data); setConfirm(false); }
    catch (e) { setErr(errorText(e, "Die Stornierung ist fehlgeschlagen. Bitte erneut versuchen.")); }
    finally { setBusy(false); }
  };

  return (
    <div className="[&_[data-testid=legal-draft-banner]]:hidden">
      <LegalShell title="Ihr Gesprächstermin">
        {err && <p role="alert" data-testid="manage-error" className="text-[#B42318]">{err}</p>}
        {!b && !err && <p className="flex items-center gap-2 text-mute"><Loader2 className="h-4 w-4 animate-spin" />Termin wird geladen …</p>}
        {b && (
          <div className="rounded-2xl border border-line bg-white p-6" data-testid="manage-booking-card">
            <div className="flex items-start gap-4">
              {b.status === "active" ? <CalendarCheck className="h-6 w-6 text-gold-deep" /> : <CalendarX className="h-6 w-6 text-[#B42318]" />}
              <div>
                <p className="font-display text-[22px] font-semibold">{b.local_date}</p>
                <p>{b.local_time} Uhr ({b.tz_label}) · Europe/Vienna · 15 Minuten, telefonisch</p>
                <p className="mt-2 font-semibold" data-testid="manage-status">{b.status === "active" ? "Status: bestätigt" : "Status: storniert"}</p>
              </div>
            </div>
            {b.status === "active" && (
              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <a className="btn btn-ink" href={`${API}/bookings/${b.id}/ics?token=${encodeURIComponent(token)}`} data-testid="manage-ics-download"><Download className="h-4 w-4" />Kalenderdatei (.ics)</a>
                {!confirm ? (
                  <button type="button" className="btn btn-line" onClick={() => setConfirm(true)} data-testid="manage-cancel-btn">Termin stornieren</button>
                ) : (
                  <button type="button" className="btn !bg-[#B42318] text-white" disabled={busy} onClick={cancel} data-testid="manage-cancel-confirm">{busy ? "Wird storniert …" : "Ja, Termin endgültig stornieren"}</button>
                )}
              </div>
            )}
          </div>
        )}
      </LegalShell>
    </div>
  );
}
